import { requiredRoles } from '@/shared/utils/require-roles'
import { UserRole } from '@depanneo/types'
import { createFileRoute } from '@tanstack/react-router'

export type CompanyTabs = 'details' | 'billing' | 'logo'

const allowedTabs: CompanyTabs[] = ['details', 'billing', 'logo']

export type EquipmentSearch = {
  tab: CompanyTabs
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/settings/company'
)({
  validateSearch: (search: Record<string, unknown>): EquipmentSearch => {
    const { tab } = search

    const validatedTab = allowedTabs.includes(tab as CompanyTabs)
      ? (tab as CompanyTabs)
      : 'details'

    return {
      tab: validatedTab,
    }
  },
  beforeLoad() {
    requiredRoles([UserRole.ADMIN])
  },
  // loader: async ({ context: { queryClient }, params: { equipmentId } }) =>
  //   queryClient.ensureQueryData({
  //     queryKey: equipmentKeys.detail(equipmentId),
  //     queryFn: () => getEquipmentById(equipmentId),
  //   }),
})
